import React, { useEffect } from 'react'
import { css } from '@emotion/react'
import Categories from 'gatsby-theme-marketplace-base/src/components/Sidebar/Categories'
import { FILTERS } from 'gatsby-theme-marketplace-base/src/constants'
import { useEnhancedList } from 'gatsby-theme-marketplace-base/src/context/EnhancedList'
import { getLocalStorageValue } from 'gatsby-theme-marketplace-base/src/utils/browser/storage'
import useHydrationContext from 'gatsby-theme-marketplace-base/src/hooks/useHydrationContext'

const categoriesCss = css`
  .collapse__label {
    padding: 8px 26px;
    align-items: center;

    > a {
      margin-bottom: 14px;
      > svg {
        margin-top: 0;
      }
    }
  }

  .collapse__content {
    margin-left: 18px;
    margin-bottom: 20px;

    div > a {
      margin-bottom: 5px;
    }
  }
`

export default (props) => {
  const { filtersOptions } = useEnhancedList()
  const hydrated = useHydrationContext()

  const categoriesOptionsContext = filtersOptions?.[FILTERS.CATEGORY.ID]
  const categoriesOptionsStorage = getLocalStorageValue(FILTERS.CATEGORY.ID)

  const categoriesOptions = categoriesOptionsContext?.length
    ? categoriesOptionsContext
    : categoriesOptionsStorage

  useEffect(() => {
    if (categoriesOptions?.length) {
      localStorage.setItem(
        FILTERS.CATEGORY.ID,
        JSON.stringify(categoriesOptions)
      )
    }
  }, [categoriesOptions])

  return (
    <Categories
      isOpenOnInit={false}
      options={hydrated ? categoriesOptions : []}
      label="Apps & integrations"
      css={categoriesCss}
      {...props}
    />
  )
}
